<script setup lang="ts">
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent } from '@/components/ui/dropdown-menu';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components/ui/select';
import { ChevronDownIcon } from 'lucide-vue-next';
import { onMounted, ref, watch } from 'vue';
import { LOCALSTORAGE_KEYS } from './printOrder';

const fontSizeRem = ref(0.8);
const fontWeight = ref('normal');

onMounted(() => {
    fontSizeRem.value = localStorage.hasOwnProperty(LOCALSTORAGE_KEYS.FONT_SIZE_REM) ? Number(localStorage.getItem(LOCALSTORAGE_KEYS.FONT_SIZE_REM)) : 0.8;
    fontWeight.value = localStorage.getItem(LOCALSTORAGE_KEYS.FONT_WEIGHT) ?? 'normal';
});

watch(fontSizeRem, (newVal) => {
    localStorage.setItem(LOCALSTORAGE_KEYS.FONT_SIZE_REM, newVal.toString());
});

watch(fontWeight, (newVal) => {
    localStorage.setItem(LOCALSTORAGE_KEYS.FONT_WEIGHT, newVal);
});
</script>
<template>
    <DropdownMenu>
        <DropdownMenuTrigger>
            <slot name="trigger">
                <ChevronDownIcon class="cursor-pointer bg-secondary p-1 h-full rounded-md" />
            </slot>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
            <div class="m-4 p-2">
                <div>
                    <Label for="fontSizeRem">
                        Font Size (rem)
                    </Label>
                    <Input id="fontSizeRem"
                           type="number"
                           step="0.1"
                           min="0.1"
                           max="3"
                           v-model="fontSizeRem"
                       @input="fontSizeRem = Number($event.target.value) || 0" />
                </div>
                <div>
                    <Label for="fontWeight">
                        Font Weight
                    </Label>
                    <Select v-model="fontWeight">
                        <SelectTrigger class="w-full">
                            <SelectValue placeholder="Select font weight" />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectItem value="normal">Normal</SelectItem>
                            <SelectItem value="bold">Bold</SelectItem>
                        </SelectContent>
                    </Select>
                </div>
            </div>
        </DropdownMenuContent>
    </DropdownMenu>
</template>